var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"speakers"}},[_c('v-sheet',{staticClass:"mx-auto container-speaker",attrs:{"elevation":"8"}},[_c('h1',{staticClass:"titles"},[_vm._v("Palestrantes")]),_c('AppSpeakersSlide')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }